import { createContext } from "react";

const MapContext = createContext({
  map: null,
  mapLoaded: false,
  drawMode: null,
  setDrawMode: null
});

export default MapContext;
